// 3rd
import { Model } from '@vuex-orm/core';

// models
import Product from './Product';

// utils
import env from '../utils/env';
import {
    API_ENDPOINT_FETCH_WISHLIST,
    API_ENDPOINT_POST_ADD_TO_WISHLIST,
    API_ENDPOINT_POST_REMOVE_FROM_WISHLIST,
    LOADER_FETCH_WISHLIST,
    LOADER_SUBMIT_WISHLIST,
} from '../utils/constants';
import {
    api,
    authHeaders,
    errorHandler
} from '../utils/api';

export default class WishlistEntry extends Model {
    static entity = 'wishlist-entries';

    static fields() {
        return {
            id: this.attr(null),
            product_id: this.attr(null),
            product: this.belongsTo(Product, 'product_id'),
        }
    }

    // api calls
    static async fetch() {
        WishlistEntry.store().dispatch('wait/start', LOADER_FETCH_WISHLIST);

        const response = await api.get(API_ENDPOINT_FETCH_WISHLIST, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data: { wishlist } } = response;

        WishlistEntry.insert({
            data: wishlist,
        });

        WishlistEntry.store().dispatch('wait/end', LOADER_FETCH_WISHLIST);
    }

    static async add(productId) {
        WishlistEntry.store().dispatch('wait/start', LOADER_SUBMIT_WISHLIST);

        const response = await api.post(API_ENDPOINT_POST_ADD_TO_WISHLIST, { product_id: Number(productId) }, authHeaders()).catch(errorHandler);
        const { data: { item } } = response;
        WishlistEntry.insert({
            data: item,
        });

        WishlistEntry.store().dispatch('wait/end', LOADER_SUBMIT_WISHLIST);
    }

    static async remove(productId) {
        WishlistEntry.store().dispatch('wait/start', LOADER_SUBMIT_WISHLIST);

        await api.post(API_ENDPOINT_POST_REMOVE_FROM_WISHLIST, { product_id: Number(productId) }, authHeaders()).catch(errorHandler);

        WishlistEntry.delete((entry) => {
            return entry.product_id === Number(productId);
        });

        WishlistEntry.store().dispatch('wait/end', LOADER_SUBMIT_WISHLIST);
    }

    // getters
    static getAll() {
        return WishlistEntry.query().with('product.required_rank').all();
    }

    static getRandom() {
        const wishlistEntries = this.getAll();
        // the sort method is randomizing the array entries
        return wishlistEntries.sort(() => .5 - Math.random()).slice(0, 1);
    }

    static getRandomForWidget() {
        const wishlistEntries = this.getAll();
        // the sort method is randomizing the array entries
        return wishlistEntries.sort(() => .5 - Math.random()).slice(0, env('dashboard-wishlist-limit'));
    }
}
